module.exports = __webpack_public_path__ + "static/media/progress-1.b4d29153.gif";